import * as React from 'react';
import {connect} from 'react-redux';

import {applyFilterSubmission, getFilterableFields} from 'nutshell-core';

import {convertToObj} from 'nutshell-core/filter';
import type {FilterObject, FormattedValue, CoreEntityType} from 'nutshell-core/types';

import {appHistory} from '../../history';
import type {NutshellState} from '../../store';

import {FilterDrawer} from '../entity-list/filters/filter-drawer';
// @ts-expect-error
import * as dashboardActions from '../master-dashboard/dashboard-actions';
// @ts-expect-error
import * as dashboardSelectors from '../master-dashboard/dashboard-selectors';

import {CUSTOM, getReportFieldsFilterFunction} from './report-constants';
import type {ReportKey, DateRangeType, ChartListParams} from './report-types';
import * as reportsActions from './reports-actions';
import * as reportsSelectors from './reports-selectors';

type OwnProps = {
    reportKey: ReportKey;
    listParams?: ChartListParams<'leads'>;
    dateRangeType?: DateRangeType;
    activeFilters: FilterObject[];
    primaryFilters: string[];
    entityType: CoreEntityType;
    facets?: FormattedValue[];
    onParamChange: (...args: any) => any;
};
type StateProps = {
    schema: any;
    isOpen: boolean;
};
type DispatchProps = {
    fetchLeadsSchema: (...args: any) => any;
    toggleShowFilterDrawer: (...args: any) => any;
};
type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        schema: dashboardSelectors.getLeadsSchema(state),
        isOpen: reportsSelectors.getIsFilterDrawerOpen(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchLeadsSchema: () => {
            dispatch(dashboardActions.fetchLeadsSchema());
        },
        toggleShowFilterDrawer: () => {
            dispatch(reportsActions.toggleShowFilterDrawer());
        },
    };
}

export class ReportFilterDrawerComponent extends React.PureComponent<Props> {
    UNSAFE_componentWillMount() {
        this.props.fetchLeadsSchema();
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const shouldOpen = urlParams.get('shouldOpenFilters') === 'true';

        if (shouldOpen && !this.props.isOpen) {
            this.props.toggleShowFilterDrawer();

            urlParams.delete('shouldOpenFilters');
            const newSearch = urlParams.toString();
            const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
            appHistory.replace(newUrl);
        }
    }

    render() {
        return (
            <FilterDrawer
                hasTopBorder={true}
                activeFilters={this.props.activeFilters}
                primaryFilters={this.props.primaryFilters}
                entityType={this.props.entityType}
                isOpen={this.props.isOpen}
                // @ts-expect-error
                fields={this.getReportFields()}
                facets={this.props.facets}
                onSubmitFilter={this.handleFilterSubmit}
                onRemoveFilter={this.handleFilterRemove}
            />
        );
    }

    getReportFields = () => {
        let fieldFilterFunction;
        if (this.props.reportKey === CUSTOM) {
            // @ts-expect-error
            fieldFilterFunction = (fieldName) => ![this.props.dateRangeType].includes(fieldName);
        } else {
            fieldFilterFunction = getReportFieldsFilterFunction(this.props.reportKey);
        }

        return getFilterableFields(this.props.schema, fieldFilterFunction);
    };

    /**
     * Takes a filterObj and either updates the existing version of that
     * filter or tacks it on as a new filter to our filters state.
     * @param  {object} filterObj  Filter object to update/apply
     * @return {void}
     */
    handleFilterSubmit = (filterObj: FilterObject) => {
        const newFilters = applyFilterSubmission(this.props.activeFilters, filterObj);
        const newParams: Record<string, any> = {};
        newParams.filter = convertToObj(newFilters);
        if (this.props.listParams) {
            newParams.list = {...this.props.listParams, page: 1};
        }
        this.props.onParamChange(newParams, false);
    };

    /**
     * Takes a filterKey (read: `owner`, `confidence`) and removes that
     * filter from the current set of filters.
     *
     * @param  {string} filterKey name of filter to remove
     * @return {void}
     */
    handleFilterRemove = (filterKey: string) => {
        const newFilters = this.props.activeFilters.filter(
            (filterObj) => !Object.prototype.hasOwnProperty.call(filterObj, filterKey)
        );
        this.props.onParamChange({filter: convertToObj(newFilters)}, false);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

export const ReportFilterDrawer = connector(ReportFilterDrawerComponent);
